import api from "common/api";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import usePageTitle from "common/usePageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

function ForgotPasswordInitial() {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  usePageTitle("Zaboravljena lozinka");

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Neispravna email adresa")
      .required("Unesite email adresu"),
  });

  const handleSubmit = async (values: { email: string }) => {
    setLoading(true);
    try {
      await api.post("/accounts/users/reset_password/", {
        email: values.email,
      });
      setEmailSent(true);
    } catch (error: any) {
      toast.error("Dogodila se greška. Molimo pokušajte ponovo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row
      className="d-flex justify-content-center align-items-center"
      style={{ height: "95vh" }}
    >
      <Col md={8} lg={6} xs={12}>
        <div className="border border-2 border-primary"></div>
        <Card className="shadow px-4">
          <Card.Body>
            <div className="mb-3 mt-md-4">
              <h2 className="fw-bold mb-2 text-center text-uppercase ">
                Zaboravljena Lozinka
              </h2>
              {emailSent ? (
                <p>
                  Ako je unesena ispravna email adresa, email za resetiranje
                  lozinke je poslan.
                </p>
              ) : (
                <>
                  <p>
                    Unesite svoju email adresu kako biste dobili upute za
                    resetiranje lozinke.
                  </p>
                  <div className="mb-3">
                    <Formik
                      initialValues={{ email: "" }}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        touched,
                      }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                          <Form.Group
                            className="mb-3"
                            controlId="formGroupEmail"
                          >
                            <Form.Label>Email adresa</Form.Label>
                            <Form.Control
                              required
                              type="email"
                              placeholder="Unesite email"
                              name="email"
                              value={values.email}
                              onChange={handleChange}
                              isInvalid={touched.email && !!errors.email}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.email}
                            </Form.Control.Feedback>
                          </Form.Group>

                          <div className="d-grid">
                            <Button
                              variant="primary"
                              type="submit"
                              disabled={loading}
                            >
                              {loading ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                "Pošalji"
                              )}
                            </Button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </>
              )}
              <p className="mt-3">
                <Link to="/prijava" className="text-primary fw-bold">
                  Povratak na login
                </Link>
              </p>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default ForgotPasswordInitial;
